import { useState } from 'react';
export const useAlert = (initalValue?: boolean): [boolean, () => void, () => void] => {
    const [isAlertOpen, setIsAlertOpen] = useState<boolean>(initalValue ? initalValue : false);
    const showAlert = () => setIsAlertOpen(true);
    const hideAlert = () => setIsAlertOpen(false);
    return [isAlertOpen, showAlert, hideAlert];
};
